export default __webpack_public_path__ + "assets/images/3352cbbf97ec1a9b94b9d060c481dcb7.png";